<div class="p-4 md:p-6 w-full">

  <!-- Header -->
  <h1 class="text-2xl font-bold text-gray-800 flex items-center">
    <mat-icon style="color: #1C593D; margin-right: 8px;">sync_alt</mat-icon>
    Centralización de Depósitos · Binance Link
    <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
      {{ totalItems }} registros
    </span>
  </h1>
  <span class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2">
    {{ totalItems }} registros
  </span>

  <!-- ════════ KPI: Volúmenes ════════ -->
  <div *ngIf="dashboard" class="mt-4 grid grid-cols-2 md:grid-cols-4 gap-3">
    <div class="kpi-card">
      <span class="kpi-label">Hoy</span>
      <p class="kpi-count">{{ dashboard.countCompleted.today }} <span class="kpi-count-unit">dep.</span></p>
      <p class="kpi-amount">{{ formatAmount(dashboard.amountCompleted.today) }} USDT</p>
    </div>
    <div class="kpi-card">
      <span class="kpi-label">Últimos 7 días</span>
      <p class="kpi-count">{{ dashboard.countCompleted.last7Days }}</p>
      <p class="kpi-amount">{{ formatAmount(dashboard.amountCompleted.last7Days) }} USDT</p>
    </div>
    <div class="kpi-card">
      <span class="kpi-label">Últimos 30 días</span>
      <p class="kpi-count">{{ dashboard.countCompleted.last30Days }}</p>
      <p class="kpi-amount">{{ formatAmount(dashboard.amountCompleted.last30Days) }} USDT</p>
    </div>
    <div class="kpi-card">
      <span class="kpi-label">Histórico</span>
      <p class="kpi-count">{{ dashboard.countCompleted.allTime }}</p>
      <p class="kpi-amount">{{ formatAmount(dashboard.amountCompleted.allTime) }} USDT</p>
    </div>
  </div>

  <!-- ════════ KPI: Status + Alertas ════════ -->
  <div *ngIf="dashboard" class="mt-3 grid grid-cols-2 md:grid-cols-6 gap-3">
    <div class="status-card" [style.border-color]="statusBg('PENDING')">
      <span class="status-card-label" [style.color]="statusBg('PENDING')">PENDING</span>
      <p class="status-card-count">{{ dashboard.countsByStatus.PENDING }}</p>
    </div>
    <div class="status-card" [style.border-color]="statusBg('TRANSFERRED')">
      <span class="status-card-label" [style.color]="statusBg('TRANSFERRED')">TRANSFERRED</span>
      <p class="status-card-count">{{ dashboard.countsByStatus.TRANSFERRED }}</p>
    </div>
    <div class="status-card" [style.border-color]="statusBg('COMPLETED')">
      <span class="status-card-label" [style.color]="statusBg('COMPLETED')">COMPLETED</span>
      <p class="status-card-count">{{ dashboard.countsByStatus.COMPLETED }}</p>
    </div>
    <div class="status-card" [style.border-color]="statusBg('PARTIAL')">
      <span class="status-card-label" [style.color]="statusBg('PARTIAL')">PARTIAL</span>
      <p class="status-card-count">{{ dashboard.countsByStatus.PARTIAL }}</p>
    </div>
    <div class="status-card" [style.border-color]="statusBg('FAILED')">
      <span class="status-card-label" [style.color]="statusBg('FAILED')">FAILED</span>
      <p class="status-card-count">{{ dashboard.countsByStatus.FAILED }}</p>
    </div>
    <div class="alert-card"
      [class.alert-card-danger]="dashboard.alertsCount > 0"
      [class.alert-card-ok]="dashboard.alertsCount === 0"
      (click)="dashboard.alertsCount > 0 && filterByAlerts()">
      <span class="alert-card-label">
        <mat-icon style="font-size: 14px; width: 14px; height: 14px;">
          {{ dashboard.alertsCount > 0 ? 'warning' : 'check_circle' }}
        </mat-icon>
        Alertas
      </span>
      <p class="alert-card-count">{{ dashboard.alertsCount }}</p>
    </div>
  </div>

  <!-- Footer info -->
  <div *ngIf="dashboard" class="mt-3 text-xs text-gray-500 flex flex-wrap gap-x-4 gap-y-1">
    <span *ngIf="dashboard.lastCompletedAt">
      Última centralización: <strong style="color: #1e5a3f;">{{ relativeTime(dashboard.lastCompletedAt) }}</strong>
    </span>
    <span *ngIf="dashboard.nextRunEstimatedAt">
      Próximo tick estimado: <strong style="color: #1e5a3f;">{{ relativeTime(dashboard.nextRunEstimatedAt) }}</strong>
    </span>
  </div>

  <!-- ════════ Filtros ════════ -->
  <div class="mt-5 bg-white p-4 md:p-5 rounded-xl shadow-md border border-gray-100">
    <div class="flex items-center gap-2 mb-3">
      <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">filter_list</mat-icon>
      <span class="text-sm font-semibold" style="color: #1e5a3f;">Filtros</span>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
      <div class="filter-group">
        <label class="filter-label">Estado</label>
        <select [(ngModel)]="filterStatus" (change)="onStatusChange()" class="filter-input">
          <option [ngValue]="''">Todos</option>
          <option *ngFor="let s of statusOptions" [ngValue]="s">{{ s }}</option>
        </select>
      </div>

      <div class="filter-group">
        <label class="filter-label">Búsqueda (email / nombre / ID)</label>
        <input type="text"
          [ngModel]="filterQ"
          (ngModelChange)="onQChange($event)"
          placeholder="Ej: usuario@example.com"
          class="filter-input" />
      </div>

      <div class="filter-group">
        <label class="filter-label">Desde</label>
        <input type="date" [(ngModel)]="filterDateFrom" (change)="onDateChange()" class="filter-input" />
      </div>

      <div class="filter-group">
        <label class="filter-label">Hasta</label>
        <input type="date" [(ngModel)]="filterDateTo" (change)="onDateChange()" class="filter-input" />
      </div>
    </div>

    <div class="flex flex-col sm:flex-row gap-2 justify-end">
      <button type="button" (click)="lookupByTxId()" class="btn-secondary">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;">search</mat-icon>
        Buscar por TxId
      </button>
      <button type="button" (click)="clearFilters()" class="btn-secondary">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;">clear</mat-icon>
        Limpiar
      </button>
      <button type="button" (click)="refresh()" class="btn-primary">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">refresh</mat-icon>
        Refrescar
      </button>
    </div>
  </div>

  <!-- Paginator -->
  <div class="flex justify-center mt-4">
    <mat-paginator
      (page)="onPageChange($event)"
      [length]="totalItems"
      [pageSize]="pageSize"
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[10, 20, 50, 100]"
      [pageIndex]="currentPage - 1"
      aria-label="Seleccionar página">
    </mat-paginator>
  </div>

  <!-- ════════ TABLA DESKTOP ════════ -->
  <div class="hidden lg:block mt-4 overflow-x-auto rounded-xl shadow-lg border border-gray-100">
    <table mat-table [dataSource]="rows" class="w-full">
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let row" class="text-xs" [title]="formatDateLong(row.createdAt)">
          {{ formatDateShort(row.createdAt) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="usuario">
        <th mat-header-cell *matHeaderCellDef>Usuario</th>
        <td mat-cell *matCellDef="let row">
          <div class="text-xs font-semibold" style="color: #374151;">{{ row.userFullName || '—' }}</div>
          <div class="text-xs" style="color: #6b7280;">{{ row.userEmail || '—' }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="subAccount">
        <th mat-header-cell *matHeaderCellDef>Sub-cuenta</th>
        <td mat-cell *matCellDef="let row">
          <span class="text-xs font-mono" style="color: #2563eb;">{{ row.subAccountId }}</span>
          <button type="button" (click)="copy(row.subAccountId, 'Sub-cuenta copiada')" class="copy-btn-inline" title="Copiar">
            <mat-icon style="font-size: 12px; width: 12px; height: 12px;">content_copy</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Monto</th>
        <td mat-cell *matCellDef="let row" class="text-xs font-bold" style="color: #1e5a3f;">
          {{ formatAmount(row.amount) }} {{ row.coin }}
        </td>
      </ng-container>

      <ng-container matColumnDef="txId">
        <th mat-header-cell *matHeaderCellDef>TxId</th>
        <td mat-cell *matCellDef="let row">
          <span class="text-xs font-mono" style="color: #6b7280;" [title]="row.txId">{{ shortTx(row.txId) }}</span>
          <button *ngIf="row.txId" type="button" (click)="copy(row.txId, 'TxId copiado')" class="copy-btn-inline" title="Copiar">
            <mat-icon style="font-size: 12px; width: 12px; height: 12px;">content_copy</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let row">
          <span class="px-2 py-1 inline-flex text-xs font-bold rounded-full"
            [style.background]="statusBg(row.status)"
            [style.color]="statusColor(row.status)">
            {{ row.status }}
          </span>
          <mat-icon *ngIf="needsAttention(row.status)"
            style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; vertical-align: middle; margin-left: 4px;"
            title="Requiere atención">warning</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="acciones" stickyEnd>
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let row">
          <button type="button" (click)="openDetail(row)" title="Ver detalle"
            style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['createdAt','usuario','subAccount','amount','txId','status','acciones']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['createdAt','usuario','subAccount','amount','txId','status','acciones']"></tr>
    </table>

    <div *ngIf="rows.length === 0" class="p-8 text-center text-gray-500 text-sm">
      <mat-icon style="font-size: 32px; width: 32px; height: 32px; color: #9ca3af;">inbox</mat-icon>
      <p class="mt-2" *ngIf="!filterStatus && !filterQ && !filterDateFrom && !filterDateTo">
        Todavía no se procesaron depósitos. El cron corre cada 5 min y centraliza automáticamente.
      </p>
      <p class="mt-2" *ngIf="filterStatus || filterQ || filterDateFrom || filterDateTo">
        Ningún resultado con esos filtros.
        <button type="button" (click)="clearFilters()" class="link-btn">Limpiar filtros</button>
      </p>
    </div>
  </div>

  <!-- ════════ CARDS MOBILE ════════ -->
  <div class="lg:hidden mt-4 space-y-3">
    <div *ngFor="let row of rows"
      class="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-200"
      [style.border]="expandedRowId === row.id ? '2px solid #1C593D' : '1px solid #e5e7eb'">
      <div class="flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleRow(row.id)"
        [style.background]="expandedRowId === row.id ? '#f0fdf4' : 'white'">
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <span class="px-2 py-0.5 inline-flex text-xs font-bold rounded-full shrink-0"
            [style.background]="statusBg(row.status)"
            [style.color]="statusColor(row.status)">
            {{ row.status }}
          </span>
          <span class="text-xs font-semibold truncate" style="color: #374151;">{{ row.userFullName }}</span>
        </div>
        <div class="flex items-center gap-2 shrink-0">
          <span class="text-sm font-bold" style="color: #1e5a3f;">
            {{ formatAmount(row.amount) }} {{ row.coin }}
          </span>
          <mat-icon style="color: #6b7280; transition: transform 0.2s ease;"
            [style.transform]="expandedRowId === row.id ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
      </div>

      <div *ngIf="expandedRowId === row.id" class="px-3 pb-3">
        <div class="grid grid-cols-2 gap-2 text-xs mb-3">
          <div>
            <span style="color: #6b7280; font-weight: 600;">Fecha</span>
            <p style="color: #374151; font-weight: 500;">{{ formatDateShort(row.createdAt) }}</p>
          </div>
          <div>
            <span style="color: #6b7280; font-weight: 600;">Email</span>
            <p style="color: #374151; font-weight: 500; word-break: break-all;">{{ row.userEmail }}</p>
          </div>
          <div>
            <span style="color: #6b7280; font-weight: 600;">Sub-cuenta</span>
            <p class="font-mono" style="color: #2563eb;">{{ row.subAccountId }}</p>
          </div>
          <div>
            <span style="color: #6b7280; font-weight: 600;">TxId</span>
            <p class="font-mono" style="color: #6b7280; word-break: break-all;">{{ shortTx(row.txId) }}</p>
          </div>
        </div>
        <button (click)="openDetail(row); $event.stopPropagation()"
          style="width: 100%; display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 10px; border: 1px solid #bfdbfe; border-radius: 8px; background: #eff6ff; cursor: pointer; font-size: 0.8rem; font-weight: 600; color: #2563eb;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #2563eb;">visibility</mat-icon>
          Ver detalle
        </button>
      </div>
    </div>

    <div *ngIf="rows.length === 0" class="p-8 text-center text-gray-500 text-sm bg-white rounded-xl shadow-sm">
      <p *ngIf="!filterStatus && !filterQ && !filterDateFrom && !filterDateTo">
        Todavía no se procesaron depósitos. El cron corre cada 5 min.
      </p>
      <p *ngIf="filterStatus || filterQ || filterDateFrom || filterDateTo">
        Ningún resultado con esos filtros.
        <button type="button" (click)="clearFilters()" class="link-btn">Limpiar filtros</button>
      </p>
    </div>
  </div>

</div>
